import { useForm } from "react-hook-form";

import { BookingScheduleDay } from "@/lib/types/schedule-types";

export type BookListingFormValues = {
  schedule: BookingScheduleDay[];
  attendeePricingTierMax: number;
};

export const useBookListingForm = ({
  defaultValues,
}: {
  defaultValues: BookListingFormValues;
}) => {
  const bookListingForm = useForm<BookListingFormValues>({
    defaultValues,
  });

  return bookListingForm;
};
